import { render } from "./ctrl-bet-box-group.vue?vue&type=template&id=66facc7d&scoped=true&ts=true"
import script from "./ctrl-bet-box-group.vue?vue&type=script&lang=ts"
export * from "./ctrl-bet-box-group.vue?vue&type=script&lang=ts"

import "./ctrl-bet-box-group.vue?vue&type=style&index=0&id=66facc7d&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66facc7d"]])

export default __exports__